import React from 'react';
import styled from 'styled-components';

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex-shrink: 0;
  color: inherit;
  line-height: 0;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

/**
 * 모듈 레일 공통 아이콘 스펙
 * - viewBox 24, 콘텐츠 약 4~20 (광학 크기 통일)
 * - stroke 1.75 / round caps — 22px에서도 무게감 동일
 * - 복잡도 2~4 path, 장식·보조 화살 없음
 */
const Svg = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {children}
  </svg>
);

const ICONS = {
  /** 인사관리 — 구성원 */
  users: (
    <Svg>
      <circle cx="9" cy="8" r="3.25" />
      <path d="M3.5 19.5v-1.1c0-2.2 1.8-4 4-4h3c2.2 0 4 1.8 4 4v1.1" />
      <circle cx="16.75" cy="8.5" r="2.5" />
      <path d="M20.5 19.5v-.7c0-1.7-1.2-3.1-2.9-3.4" />
    </Svg>
  ),
  /** 기준정보 — 톱니(8방향·동일 선무게) */
  settings: (
    <Svg>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 3.25v2.5M12 18.25v2.5M3.25 12h2.5M18.25 12h2.5M5.64 5.64l1.77 1.77M16.59 16.59l1.77 1.77M5.64 18.36l1.77-1.77M16.59 7.41l1.77-1.77" />
    </Svg>
  ),
  /** 예산관리 — 파이차트 */
  pieChart: (
    <Svg>
      <circle cx="12" cy="12" r="8.25" />
      <path d="M12 3.75V12l6.2 3.6" />
    </Svg>
  ),
  /** 지출관리 — 지폐 */
  banknote: (
    <Svg>
      <rect x="3.5" y="6.5" width="17" height="11" rx="2" />
      <circle cx="12" cy="12" r="2.25" />
      <path d="M6.75 10v4M17.25 10v4" />
    </Svg>
  ),
  /** 수입관리 — 금전 자루 */
  moneyBag: (
    <Svg>
      <path d="M9 8.5c0-1.4 1.3-2.5 3-2.5s3 1.1 3 2.5c0 3.5-1.7 7-3 8.5-1.3-1.5-3-5-3-8.5z" />
      <path d="M10.4 6.4c.5-1.2 1.1-2 1.6-2.4.5.4 1.1 1.2 1.6 2.4" />
      <path d="M12 10.5v3.2M10.8 12.1h2.4" />
    </Svg>
  ),
  /** 계약관리 — 클립보드 */
  clipboard: (
    <Svg>
      <rect x="6.5" y="5.5" width="11" height="14" rx="1.5" />
      <path d="M9 5.5V4.75A1.75 1.75 0 0 1 10.75 3h2.5A1.75 1.75 0 0 1 15 4.75V5.5" />
      <path d="M9.5 10.5h5M9.5 13.5h5M9.5 16.5h3.5" />
    </Svg>
  ),
  /** 세무관리 — 신고서 */
  receipt: (
    <Svg>
      <path d="M7 4.5h10v15l-1.4-1-1.4 1-1.4-1-1.4 1-1.4-1-1.4 1-1.6-1V4.5z" />
      <path d="M9.5 8.5h5M9.5 11.5h5M9.5 14.5h3" />
    </Svg>
  ),
  /** 자료이관 — 문서 이동 */
  transfer: (
    <Svg>
      <rect x="4" y="5.5" width="9.5" height="13" rx="1.4" />
      <path d="M7 9h3.5M7 12h3.5M7 15h2.2" />
      <path d="M14.5 9.5h5.2M17.2 7.2L19.7 9.5 17.2 11.8" />
      <path d="M19.7 15.5H14.5M16.8 13.2L14.3 15.5 16.8 17.8" />
    </Svg>
  ),
};

export const MODULE_MENU_ICON_KEYS = Object.keys(ICONS);

/**
 * 상단 모듈(인사·기준·예산·지출·수입) 접힘 레일 아이콘
 * @param {'users'|'settings'|'pieChart'|'banknote'|'moneyBag'|'clipboard'|'receipt'|'transfer'} name
 */
const ModuleMenuIcon = ({ name, size = 22, title }) => {
  const svg = name && ICONS[name] ? ICONS[name] : null;
  if (!svg) return null;
  return (
    <Wrap $size={size} title={title} aria-hidden={title ? undefined : true}>
      {svg}
    </Wrap>
  );
};

export default ModuleMenuIcon;
